import React from "react"
import { useStaticQuery, graphql } from "gatsby"

const Seo = props => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          author
          siteUrl
          locale
          fbappid
        }
      }
      fileHeader: file(name: { eq: "site-header" }) {
        childImageSharp {
          original {
            src
            width
            height
          }
        }
      }
      fileProf: file(name: { eq: "profile" }) {
        childImageSharp {
          original {
            src
            width
            height
          }
        }
      }
    }
  `)

  const title = props.pagetitle
    ? `${props.pagetitle} | ${data.site.siteMetadata.title}`
    : `${data.site.siteMetadata.title} | ${data.site.siteMetadata.description}`

  const description = props.pagedesc || data.site.siteMetadata.description

  const url = props.pagepath
    ? `${data.site.siteMetadata.siteUrl}${props.pagepath}`
    : data.site.siteMetadata.siteUrl

  const type = props.pagetype ? props.pagetype : `website`

  const imgurl = props.pageimg
    ? `${data.site.siteMetadata.siteUrl}${props.pageimg}`
    : `${data.site.siteMetadata.siteUrl}${data.fileHeader.childImageSharp.original.src}`

  const imgw = props.pageimgw || data.fileHeader.childImageSharp.original.width
  const imgh = props.pageimgh || data.fileHeader.childImageSharp.original.height

  const baseSchema = [
    {
      "@type": ["Person", "Organization"],
      "@id": `${data.site.siteMetadata.siteUrl}/#/schema/person/d895badac4e78d6e704fc277dd39a550`,
      name: data.site.siteMetadata.author,
      image: {
        "@type": "ImageObject",
        inLanguage: "ja",
        "@id": `${data.site.siteMetadata.siteUrl}/#/schema/person/image/`,
        url:
          data.site.siteMetadata.siteUrl +
          data.fileProf.childImageSharp.original.src,
        contentUrl:
          data.site.siteMetadata.siteUrl +
          data.fileProf.childImageSharp.original.src,
        width: data.fileProf.childImageSharp.original.width,
        height: data.fileProf.childImageSharp.original.height,
        caption: data.site.siteMetadata.author,
      },
      logo: {
        "@id": `${data.site.siteMetadata.siteUrl}/#/schema/person/image/`,
      },
      description:
        "節税からの確定拠出年金で2016年4月から投資デビュー。資産は現在1,800万円程",
    },
    {
      "@type": "WebSite",
      "@id": `${data.site.siteMetadata.siteUrl}/#website`,
      url: data.site.siteMetadata.siteUrl,
      name: data.site.siteMetadata.title,
      description: data.site.siteMetadata.description,
      publisher: {
        "@id": `${data.site.siteMetadata.siteUrl}/#/schema/person/d895badac4e78d6e704fc277dd39a550`,
      },
      inLanguage: "ja",
    },
  ]

  const schema = {
    "@context": "https://schema.org",
    "@graph": [...(props.pageSchema || ""), ...baseSchema],
  }

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:site_name" content={data.site.siteMetadata.title} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={imgurl} />
      <meta property="og:image:width" content={imgw} />
      <meta property="og:image:height" content={imgh} />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </>
  )
}

export default Seo
